import React from 'react';
import { RouteMenu } from "model/other";
import UrlConfig from 'config/url.config';


const Dashboard = React.lazy(() => import ("screens/dashboard"));
const ClientFAQs = React.lazy(() => import ("screens/client-faqs"));
const Suggestions = React.lazy(() => import ("screens/suggestions"));
const Playground = React.lazy(() => import ("screens/playground"));
const ChatBotSettings = React.lazy(() => import ("screens/chat-bot-settings"));
const GrokRag = React.lazy(() => import ("screens/grok-rag"));
const AIWorkspace = React.lazy(() => import ("screens/ai-workspace"));
const WebsiteBuilder = React.lazy(() => import ("screens/website-builder"));
const PriceSheet = React.lazy(() => import ("screens/price-sheet"));
const GoogleAdsHourlyCoC = React.lazy(() => import ("screens/google-ads/hourly-coc"));
const GoogleAdsHighestCostKw = React.lazy(() => import ("screens/google-ads/highest-cost-keywords"));
const GoogleAdsLowestConvKw = React.lazy(() => import ("screens/google-ads/lowest-conv-keywords"));

const menu: Array<RouteMenu> = [
  {
    path: UrlConfig.HOME,
    exact: true,
    title: "Dashboard",
    icon: "icon-dashboard",
    component: Dashboard,
    key: "1",
    isShow: true,
    header: null,
    subMenu: [],
  },
  {
    path: UrlConfig.FAQS,
    exact: true,
    title: "FAQs",
    icon: "icon-customer",
    component: ClientFAQs,
    key: "3",
    isShow: true,
    header: null,
    subMenu: [
      {
        path: UrlConfig.SUGGESTIONS,
        exact: true,
        title: "Suggestions",
        icon: "icon-dot",
        component: Suggestions,
        key: "2-4",
        isShow: true,
        header: null,
        subMenu: [],
      },
    ],
  },
  {
    path: UrlConfig.FAQS,
    exact: true,
    title: "Chat Bot",
    icon: "icon-customer",
    component: ClientFAQs,
    key: "2",
    isShow: true,
    header: null,
    subMenu: [
      {
        path: UrlConfig.PLAYGROUND,
        exact: true,
        title: "Playground",
        icon: "icon-dot",
        component: Playground,
        key: "2-1",
        isShow: true,
        header: null,
        subMenu: [],
      },
      {
        path: UrlConfig.CHAT_BOT_SETTINGS,
        exact: true,
        title: "Settings",
        icon: "icon-dot",
        component: ChatBotSettings,
        key: "2-2",
        isShow: true,
        header: null,
        subMenu: [],
      },
    ],
  },
  {
    path: UrlConfig.GROK_RAG,
    exact: true,
    title: "Grok Settings",
    icon: "icon-customer",
    component: GrokRag,
    key: "4",
    isShow: true,
    header: null,
    subMenu: [
      {
        path: UrlConfig.GROK_RAG,
        exact: true,
        title: "Grok RAG",
        icon: "icon-dot",
        component: GrokRag,
        key: "4-1",
        isShow: true,
        header: null,
        subMenu: [],
      }
    ],
  },
  {
    path: UrlConfig.AI_WORKSPACE,
    exact: true,
    title: "AI Workspace",
    icon: "icon-customer",
    component: AIWorkspace,
    key: "5",
    isShow: true,
    header: null,
    subMenu: [],
  },
  {
    path: UrlConfig.WEBSITE_BUILDER,
    exact: true,
    title: "Website Builder",
    icon: "icon-customer",
    component: WebsiteBuilder,
    key: "6",
    isShow: true,
    header: null,
    subMenu: [],
  },
  {
    path: UrlConfig.PRICE_SHEET,
    exact: true,
    title: "Price Sheet",
    icon: "icon-customer",
    component: PriceSheet,
    key: "8",
    isShow: true,
    header: null,
    subMenu: [],
  },
  // {
  //   path: UrlConfig.GOOGLE_ADS_HOURLY_COC,
  //   exact: true,
  //   title: "Google Ads Analytics",
  //   icon: "icon-customer",
  //   component: GoogleAdsHourlyCoC,
  //   key: "7",
  //   isShow: true,
  //   header: null,
  //   subMenu: [
  //     {
  //       path: UrlConfig.GOOGLE_ADS_HOURLY_COC,
  //       exact: true,
  //       title: "Cost/Conv by Time",
  //       icon: "icon-dot",
  //       component: GoogleAdsHourlyCoC,
  //       key: "7-1",
  //       isShow: true,
  //       header: null,
  //       subMenu: [],
  //     },
  //     {
  //       path: UrlConfig.GOOGLE_ADS_HIGHEST_COST_KEYWORDS,
  //       exact: true,
  //       title: "Highest Cost Keywords",
  //       icon: "icon-dot",
  //       component: GoogleAdsHighestCostKw,
  //       key: "7-2",
  //       isShow: true,
  //       header: null,
  //       subMenu: [],
  //     },
  //     {
  //       path: UrlConfig.GOOGLE_ADS_LOWEST_CONV_KEYWORDS,
  //       exact: true,
  //       title: "Lowest Conv. Keywords",
  //       icon: "icon-dot",
  //       component: GoogleAdsLowestConvKw,
  //       key: "7-3",
  //       isShow: true,
  //       header: null,
  //       subMenu: [],
  //     },
  //   ],
  // },
]

export default menu;